import React, { useMemo } from 'react';
import { usePermissions } from '../../utils/usePermissions';

const AI_CHAT_BASE_URL = (import.meta.env.VITE_AI_CHAT_URL as string) || 'https://aiab3.qomeq.kz/embed/embed-chat.html';
const AI_CHAT_API_KEY = (import.meta.env.VITE_AI_CHAT_API_KEY as string) || '';

const AI_CHAT_AGENT_PREFIX = 'ai_chat:agent:';

export const AI_CHAT_AGENTS: Record<string, string> = {
  'sud-kz': 'Поиск судебных дел',
  'aisoip': 'Исполнительные производства',
  'doc-parser': 'Анализ документов',
};

const AgentsIframeContent: React.FC = () => {
  const { permissions } = usePermissions();

  const allowedAgents = useMemo(() => {
    const agents: string[] = [];
    for (const perm of permissions) {
      if (perm.startsWith(AI_CHAT_AGENT_PREFIX)) {
        const agentCode = perm.replace(AI_CHAT_AGENT_PREFIX, '');
        if (agentCode && AI_CHAT_AGENTS[agentCode]) {
          agents.push(agentCode);
        }
      }
    }
    if (agents.length === 0 && permissions.includes('ai_chat:view')) {
      return Object.keys(AI_CHAT_AGENTS);
    }
    return agents;
  }, [permissions]);

  const agentsParam = allowedAgents.length > 0 ? `&agents=${allowedAgents.join(',')}` : '';
  const chatUrl = `${AI_CHAT_BASE_URL}?api_key=${AI_CHAT_API_KEY}${agentsParam}`;

  return (
    <iframe
      src={chatUrl}
      title="AI Агенты"
      allow="microphone"
      style={{ flex: 1, width: '100%', border: 'none' }}
    />
  );
};

export default AgentsIframeContent;
